import { Checkbox, FormControl, Grid, Radio, RadioGroup} from "@material-ui/core";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useMemo } from "react";
import Input from "../../../../../components/Input";
import { IIndicator } from "../../../../../interfaces/IIndicator";
import Button from "../../../../../components/Button";
import { RiArrowLeftSLine, RiUserAddLine } from "react-icons/ri";
import * as S from './styles';
import { useHistory, useParams } from "react-router-dom";
import PageTitle from "../../../../../components/PageTitle";
import api from "../../../../../services/api";
import { useToast } from "../../../../../hooks/toast";
import { AxiosError } from "axios";
import { EquationEditor } from "./components/equationEditor";
import { ISensor } from "../../../../../interfaces";


const Indicator: React.FC = () => {
    const IndicatorFormRef = useRef<FormHandles>(null);
    const history = useHistory();
    const params = useParams<{id: string, indicator: string}>();
    const [sensorsList, setSensorsList] = useState<Array<{ value: string; text: string }>>([])
    
    const [indicator, setIndicator] = useState<IIndicator>({
        id: '',
        description: '',
        equation: '',
        device_id: '',
        graph_type: 0,
        acumulated: false,
        acumulate_period: 0,
        sensors: ''
    } as IIndicator);
    const [loader, setLoader] = useState(false);
    const { addToast } = useToast();

    
    const findById = useCallback(async (id: string) => {
        try {
            const { data } = await api.get<IIndicator>(`/indicators/${id}`);
            setIndicator({
                id: data.id,
                description: data.description,
                equation: data.equation,
                device_id: data.device_id,
                graph_type: data.graph_type,
                acumulated: data.acumulated,
                acumulate_period: data.acumulate_period,
                sensors: data.sensors.trim()
            });
        } catch (error) {
            const message = (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`;
    
            addToast({
                type: 'error',
                title: 'Erro ao buscar sensor',
                description: message,
            });
        }
    }, [addToast]);


    const getSensorList = useCallback(async (deviceId: string) => {
        try {
            const { data } = await api.get<ISensor[]>(`/sensors?device_id=${deviceId}`);   
            setSensorsList( data?.map(s => ({value: s.id, text: s.name }))) 
        } catch (error) {
            const message = (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`;
    
            addToast({
                type: 'error',
                title: 'Erro ao buscar sensor',
                description: message,
            });
        }
    }, [addToast])


    useEffect(() => {

        getSensorList(params.id)

        if (params.indicator)
            findById(params.indicator)
        else 
            setIndicator({...indicator, device_id: params.id})

    }, [params.id, params.indicator, findById, getSensorList, indicator]);

    function transformEquationCodeToText (equation: string){
        const regex = new RegExp(`\\b(${sensorsList.map(p => p.value).join('|')})\\b`, 'gi');
        let decoded = equation.replace(regex, (match) => sensorsList.find(q =>  q.value === match)?.text || match);
        return decoded;
    }


    function transformEquationToCode (equation: string){
        const regex = new RegExp(`\\b(${sensorsList.map(p => p.text).join('|')})\\b`, 'gi');
        let sensors: string = '';
        let encoded = equation.replace(regex, (match) => {
            let sensor = sensorsList.find(q =>  q.text === match);
            sensors += sensor && sensors.indexOf(sensor.value) < 0? sensor.value + ',' : ''
            return sensor ? sensor.value : match
          
        });
        setIndicator({ ...indicator, equation: encoded, sensors: sensors.slice(0, -1) });
    }


    async function handleIndicatorSubmit() {
        try {
            setLoader(true);
            let data = {...indicator}
            if (indicator.id && indicator.id.trim() !== '')
                await api.put<IIndicator>(`/indicators`, data);
            else{
                delete data.id
                await api.post<IIndicator>(`/indicators`, data);
            }

            history.goBack();
        } catch (error) {
            const message = (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`;
    
            addToast({
                type: 'error',
                title: 'Erro ao salvar dados!',
                description: message,
            });
        } finally {
            setLoader(false);
        }
    }
    
    const indicatorForm = useMemo(() => {
        return (
            <div>
                <Form onSubmit={() => handleIndicatorSubmit()} ref={IndicatorFormRef}>
                    <Grid item>
                        <p>Descrição</p>
                        <Input hideErrorIcon name="description" placeholder="Descrição do indicador" defaultValue={indicator.description} 
                            onChange={(e) => setIndicator({ ...indicator, description: e.target.value })}
                        />
                    </Grid>
                    <Grid item>
                        <p>Equação</p>
                        <EquationEditor onChange={(value) => transformEquationToCode(value)} suggestionTitle="Sensores" defaultValue={transformEquationCodeToText (indicator.equation)} name="equationEditor" options={sensorsList}></EquationEditor>
                    </Grid>
                    <Grid container spacing={1} style={{marginTop:'10px'}}>
                        <Grid item xs={12} sm={6}>
                            <Grid item>
                                <FormControl id="graph_type">
                                    <p id="demo-radio-buttons-group-label">Tipo de Grafico</p>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={indicator.graph_type.toString()}
                                        name="radio-buttons-group-graph_type"
                                        onChange={(e) => setIndicator({ ...indicator, graph_type: parseInt(e.target.value)} )}
                                    >
                                        <span className="radio-label"><Radio color="primary" value="0"/> Linha</span>
                                        <span className="radio-label"><Radio color="primary" value="1"/> Barra</span>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <span className="radio-label">
                                    <Checkbox name="acumulated"  color='primary' checked={indicator.acumulated}
                                            onChange={(e) => setIndicator({ ...indicator, acumulated: e.target.checked })}
                                    /> 
                                    Acumulado?
                                </span>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {indicator.acumulated && (
                                <Grid item>
                                <FormControl id="acumulate_period">
                                    <p id="demo-radio-buttons-group-label">Período Acumulo</p>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={indicator.acumulate_period.toString()}
                                        name="radio-buttons-acumulate_period"
                                        onChange={(e) => setIndicator({ ...indicator, acumulate_period: parseInt(e.target.value)} )}
                                        className="control-label"
                                    >
                                        <span className="radio-label"><Radio color="primary" value="0"/> Hora</span>
                                        <span className="radio-label"><Radio color="primary" value="1"/> Dia</span>
                                        <span className="radio-label"><Radio color="primary" value="2"/> Semana</span>
                                        <span className="radio-label"><Radio color="primary" value="3"/> Mês</span>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            )}
                            
                        </Grid>
                    </Grid>
                    <Grid item xs={12}
                        style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100px', // Altura opcional, ajuste conforme necessário
                        }}
                    >
                        {loader ? (
                        <Button>Atualizando ...</Button>
                        ) : (
                        <Button>
                            <RiUserAddLine size={20} />
                            Atualizar
                        </Button>
                        )}
                    </Grid>  
                </Form>
            </div>
            
        );
    }, [indicator,loader, setIndicator, params,sensorsList, handleIndicatorSubmit, transformEquationToCode, transformEquationCodeToText]);



    return (
        <>
            <S.GoBack>
                <button type="button" onClick={() => history.goBack()}>
                  <RiArrowLeftSLine />
                  <p>Voltar</p>
                </button>
            </S.GoBack>
            <>
            <PageTitle sub="Indicador" title="Configurar" />
            <S.Container>
                <S.Indicator>
                    {indicatorForm}
                </S.Indicator>
                
            </S.Container>
            </>
            

        </>
        
    )
}

export default Indicator;